// extracted by mini-css-extract-plugin
export default {"wrapper":"TM-z","firstToReview":"UM-z","productCards":"VM-z","productCard":"WM-z","stars":"XM-z","hidden":"YM-z"};